import { useAppSelector } from '@hooks/useRedux';
import {
  selectGracePeriodEndsAt,
  selectIsSubscriptionInGracePeriod,
} from '@store/billing';
import { AlertTriangle } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { BILLING_PAGE_PATH } from '../../util/renderConstants';

export const SubscriptionGracePeriodBanner: React.FC = () => {
  const isInGracePeriod = useAppSelector(selectIsSubscriptionInGracePeriod);
  const gracePeriodEndsAt = useAppSelector(selectGracePeriodEndsAt);

  if (!isInGracePeriod) return null;

  const deadline = gracePeriodEndsAt
    ? new Date(gracePeriodEndsAt).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : 'the deadline';

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-6 py-3 text-sm text-amber-900">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <AlertTriangle size={15} className="shrink-0 text-amber-500" />
          <span>
            Payment failed. Update your payment method before{' '}
            <strong>{deadline}</strong> to keep sales active.
          </span>
        </div>
        <Link
          to={BILLING_PAGE_PATH}
          className="shrink-0 rounded-full bg-amber-500 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white hover:bg-amber-600"
        >
          Review billing
        </Link>
      </div>
    </div>
  );
};
